import React from "react";

const StatusButton = ({ label, active }) => (
  <div
    className={`flex items-center justify-center rounded-full font-bold text-white w-[50px] py-2 ${
      active ? "bg-green-400" : "bg-gray-300"
    }`}
  >
    {label}
  </div>
);

export default StatusButton;
